import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SearchResultComponent } from '@softapps/core';
import { KtostammKundeListView } from '../list-view/ktostamm-kunde.list-view';

@Component({
  selector: 'soft-field-ok-ktostamm-kunde-search-result-view',
  imports: [KtostammKundeListView],
  templateUrl: './search-result-view.component.html',
  styleUrl: './search-result-view.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush })
export class KtostammKundeFieldOkSearchResultViewComponent
  implements SearchResultComponent<any>
{
  readonly result = input.required<any>();
}
